import { pdf } from '@react-pdf/renderer'
import { ReactElement } from 'react'

export const generatePdfBlob = async (element: ReactElement): Promise<Blob> => {
  const blob = await pdf(element).toBlob()
  return blob
}
